import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-floating-buttons',
  standalone: true,
  imports: [CommonModule, RouterLink, Icon],
  templateUrl: './floating-buttons.component.html',
  styleUrls: ['./floating-buttons.component.css'],
})
export default class FloatingButtonsComponent {
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
}
